import React from "react";

export default class ScrollToTopOnMount extends React.Component {
  	componentDidMount() {
    	window.scrollTo(0, 0);
      	document.getElementById('app-container').scrollTop = 0;
  	}

  	render() {
    	return null
  	}
}


// WEBPACK FOOTER //
// ./src/components/ScrollToTopOnMount.js